import { IMockHandler } from '@/mock/mock.handler.interface';
import { okList, okSingle } from '@/mock/mock.response.util';
import { ALL_ACTIVITY_FIXTURES, FILE_FIXTURES, ONBOARDING_FIXTURES } from '@/mock/onboarding/onboarding.fixtures';

const ID_ROUTE = /\/onboarding\/([^/?]+)$/;

export const onboardingHandler: IMockHandler = {
    matches(req: any) {
        if (req.url.includes('/assets/i18n/') || req.url.includes('assets/i18n/')) {
            return false;
        }

        return req.url.includes('/onboarding');
    },

    handle(req: any) {
        const { method, url } = req;
        const idMatch = url.match(ID_ROUTE);

        // ── GET /onboarding/activity/all ─────────────────────────────────────
        if (method === 'GET' && url.includes('/onboarding/activity/all')) {
            return okList(ALL_ACTIVITY_FIXTURES);
        }

        // ── GET /onboarding/files ─────────────────────────────────────────────
        if (method === 'GET' && url.includes('/onboarding/files')) {
            return okList(FILE_FIXTURES);
        }

        // ── GET /onboarding/:id ───────────────────────────────────────────────
        if (method === 'GET' && idMatch) {
            const found = ONBOARDING_FIXTURES.find((u) => String(u.id) === idMatch[1]);
            return found ? okSingle(found) : okSingle(null);
        }

        // ── GET | POST /onboarding  (list / search) ──────────────────────────
        if (method === 'GET' && url.endsWith('/onboarding')) {
            const page = Number(req.params.get('page') ?? 0);
            const size = Number(req.params.get('size') ?? 10);
            return okList(ONBOARDING_FIXTURES, page, size);
        }
        throw new Error(`[OnboardingHandler] unhandled: ${method} ${url}`);
    }
};
